/**
 * Handoff Mesas → POS (Cobrar / Ir a cobrar).
 * El carrito vive en Zustand, pero la hidratación de table_session puede pisarlo si
 * `tablesideCheckoutPreview` no llega por params anidados de React Navigation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TablesideHandoffCartLine = Record<string, any>;

export type TablesidePosHandoff = {
  branchId: string;
  diningTableId: string;
  openKey: string;
  checkoutPreview: boolean;
  cart: TablesideHandoffCartLine[];
};

let pending: TablesidePosHandoff | null = null;

export function commitTablesidePosHandoff(handoff: TablesidePosHandoff): void {
  pending = {
    ...handoff,
    cart: handoff.cart.map((line) => ({ ...line })),
  };
}

export function peekTablesidePosHandoff(): TablesidePosHandoff | null {
  return pending;
}

/** Consumido una sola vez al hidratar POS para esta mesa/sucursal. */
export function consumeTablesidePosHandoff(args: {
  branchId: string;
  diningTableId: string;
  openKey?: string | null;
}): TablesidePosHandoff | null {
  if (!pending) return null;
  if (pending.branchId !== args.branchId || pending.diningTableId !== args.diningTableId) {
    return null;
  }
  if (args.openKey?.trim() && pending.openKey !== args.openKey.trim()) {
    return null;
  }
  const out = pending;
  pending = null;
  return out;
}

export function clearTablesidePosHandoff(): void {
  pending = null;
}
